'use strict';
const React = require('react');
const ReactRedux = require('react-redux');
const BaseComponent = require('../../../shared/base');
const HeaderLayout = require('../../../layouts/header').HeaderLayoutComponent;
const SidebarLayout = require('../../../layouts/sidebar').SidebarLayoutComponent;
const FooterLayout = require('../../../layouts/footer').FooterLayoutComponent;

const CategoryComponent = require('./categories');
const CustomFieldComponent = require('./customfield');
const ImageModalViewComponent = require('./image-modal-view');
const NegotiateComponent = require('../../../features/pricing_type/' + process.env.PRICING_TYPE + '/add-edit/negotiate');
const CommonModule = require('../../../../public/js/common');

const { PricingFeatureComponent, mapStateToProps, mapDispatchToProps } = require('../../../features/pricing_type/' + process.env.PRICING_TYPE + '/add-edit/index');
const TabLinksComponent = require('../../../features/pricing_type/' + process.env.PRICING_TYPE + '/add-edit/tab-links');
const AddButtonComponent = require('../../../features/pricing_type/' + process.env.PRICING_TYPE + '/add-edit/add-button');

//=====================================================================================================================
class UploadEditComponent extends BaseComponent {
    constructor(props) {
        super(props);

        this.coreActive = true;
        
        this.browseFile = this.browseFile.bind(this);
        this.showTab = this.showTab.bind(this);
        this.motorSelected = [];
        this.isCountryLevel = false;
        this.regOnlyNumbers = /^[0-9\b]+$/
    }
    //-----------------------------------------------------------------------------------------------------------------
    componentDidUpdate() {
        this.checkImageIsMaximumNumber();
    }
    //-----------------------------------------------------------------------------------------------------------------
    calcPosition() {
        $('.tab-container').each(function () {
            $(this).attr('data-position', $(this).offset().top);
        });
    }
    //-----------------------------------------------------------------------------------------------------------------
    getDocHeight() {
        var D = document;
        return Math.max(
            D.body.scrollHeight, D.documentElement.scrollHeight,
            D.body.offsetHeight, D.documentElement.offsetHeight,
            D.body.clientHeight, D.documentElement.clientHeight
        );
    }
    //-----------------------------------------------------------------------------------------------------------------
    handleWindowScroll() {
        const self = this;

        $(window).scroll(function () {
            if (!self.isCountryLevel || $('.btn-next-variation').is(':visible')) {
                var scrollPosition = $(window).scrollTop();
                if (scrollPosition > 0) {
                    if ($(window).scrollTop() + $(window).height() >= self.getDocHeight()) {
                        const tab = $('.tab-container:not([style*="display: none"])').last().attr('id');
                        $('#seller-upload-tab li').removeClass('active');
                        $(`[data-tab="${tab}"]`).addClass('active');
                    } else {
                        $('#seller-upload-tab li').each(function () {
                            var currentLink = $(this);
                            var refElement = $('#' + currentLink.attr("data-tab"));
                            if (refElement.length) {
                                scrollPosition = $('.header').height() + scrollPosition;
                                if (refElement.position().top <= scrollPosition && refElement.position().top + refElement.height() > scrollPosition) {
                                    if (!self.isCountryLevel || currentLink.attr("data-tab") != 'pricing_tab') {
                                        $('#seller-upload-tab li').removeClass('active');
                                        $(this).addClass('active');
                                    }
                                }
                            }
                        });
                    }
                } else {
                    $('#seller-upload-tab li').removeClass('active');
                    $('#seller-upload-tab li:first-child').addClass('active');
                }
            }
        });
    }
    //-----------------------------------------------------------------------------------------------------------------
    prepareItem(){
        
    }
    //-----------------------------------------------------------------------------------------------------------------
    componentDidMount() {
        
        var self = this;
        //console.log("customFields",self.props.itemModel.customFields)
        //console.log("itemModel",self.props.itemModel)
        //console.log("props",self.props)

        $("li.check-category.has-child-sub").append('<div class="cat-line"></div>');
        if (typeof window !== 'undefined') {
            CommonModule.init();

            $(".cat-toggle .up").on("click", function () {
                var $this = $(this);
                var $parent = $this.parents(".parent-cat");
                var $findSubCat = $parent.find("ul.sub-cat");
                $findSubCat.slideToggle();
                $parent.find(".cat-toggle > .down").removeClass("hide");
                $this.addClass("hide");
                $parent.find(".cat-line").addClass("hide");
            });

            $(".cat-toggle .down").on("click", function () {
                var $this = $(this);
                var $parent = $this.parents(".parent-cat");
                var $findSubCat = $parent.find("ul.sub-cat");
                $findSubCat.slideToggle();
                $parent.find(".cat-toggle > .up").removeClass("hide");
                $this.addClass("hide");
                $parent.find(".cat-line").removeClass("hide");
            });

            $("li.check-category.has-child-sub").on("click", function () {
                $(this).find("li.check-category.has-child-sub").each(function () {
                    var $ulFirst = $(this).find("ul").first();
                    var $ulliFirst1 = $ulFirst.children("li").last().find("label").first().innerHeight() * 1.3;
                    var $ulliFirst = $ulFirst.children("li").last().innerHeight();
                    var newHeight = $ulliFirst + $ulliFirst1;
                    var completeHeight = parseInt(newHeight) - parseInt($(this).height());

                    if ($(this).find(".cat-line").length) {

                        $(this).find(".cat-line").css("height", Math.abs(completeHeight) + "px");
                    } else {
                        $(this).append('<div class="cat-line"></div>');
                        $(this).find(".cat-line").css("height", Math.abs(completeHeight) + "px");
                        $(this).find(".cat-line:not(:first)").remove();
                    }
                });
            });
            self.checkImageIsMaximumNumber();

            this.calcPosition();

            $("body").on('click' , '.tab-mobile' , function(){
                $("#seller-upload-tab").slideToggle();  
            });

            $("body").on("click", '#seller-upload-tab li ', function () {
                var active_text = $(this).text();
                /*$(this).parent('#seller-upload-tab').slideUp();*/
                $(".drop-box-area span").html(active_text);
            });

            this.handleWindowScroll();
            this.isCountryLevel = $('#selectCountries').length > 0;
        }

      this.sumoSelectRender()
    }
    //-----------------------------------------------------------------------------------------------------------------
    checkImageIsMaximumNumber() {
        const { images } = this.props.itemModel;
        const total = images.length;
        const maxUpload = 5;

        if (maxUpload > total) {
            $("#btn-browse").fadeIn();
            $(".add-item-box").fadeIn();
        }

        if (maxUpload <= total) {
            $("#btn-browse").fadeOut();
            $(".add-item-box").fadeOut();
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    callbackUploadItem() {
        this.checkImageIsMaximumNumber();
    }
    //-----------------------------------------------------------------------------------------------------------------
    addImage(self, data) {
        self.props.setUploadFile(data);
        self.callbackUploadItem();
    }
    //-----------------------------------------------------------------------------------------------------------------
    browseFile() {
        $(".tools").addClass("hide");
        var canvas = document.getElementById("visbleCanvas");

        if ($(".imageBox").find(canvas).length !== 0) {
            canvas.remove();
        }
        $(".upload-wapper > .upload-wrapper-container > input").val("");
    }
    //-----------------------------------------------------------------------------------------------------------------
    showTab(tabName) {
        $('.tablinks').removeClass('active');
        $('.tab-container.tabcontent').removeClass('active');
        const $container = $("html,body");
        const $totalHeaderHeight = $(".header").innerHeight() + 50;

        if (this.isCountryLevel && tabName == 'pricing_tab') {
            if ($('.btn-next-variation').is(':visible')) {
                this.props.validateNonPricingDetails((hasError) => {
                    if (!hasError) {
                        $('#basic_tab,#description_tab,#delivery_tab,#variants_tab').hide();
                        $('.btn-next-variation').hide();
                        $('#pricing_tab').show();
                        $('.btn-back-variation').show();
                        $(`[data-tab="${tabName}"]`).addClass('active');
                        $(`#${tabName}`).addClass('active');
                    } else {
                        var $scrollTo = $('.error-con').eq(0);
                        if ($scrollTo.parent().children('label').length > 0) {
                            $scrollTo = $scrollTo.parent().children('label');
                        }
                        $container.animate({
                            scrollTop: $scrollTo.offset().top - $totalHeaderHeight,
                            scrollLeft: 0
                        }, 500);
                    }
                });
            }
        } else {
            if (this.isCountryLevel && $('.btn-back-variation').is(':visible')) {
                $('#basic_tab,#description_tab,#delivery_tab,#variants_tab').show();
                $('.btn-next-variation').show();
                $('#pricing_tab').hide();
                $('.btn-back-variation').hide();
            }

            $(`[data-tab="${tabName}"]`).addClass('active');

            let tabActive = "#" + tabName;
            $(tabActive).addClass('active');
            var $scrollTo = $('.tab-container.tabcontent.active');

            $container.animate({
                scrollTop: $scrollTo.offset().top - $totalHeaderHeight,
                scrollLeft: 0
            }, 500);
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    sumoSelectRender(){
        var self = this;

        $('#selectMotor').SumoSelect({  placeholder: 'Select Here',csvDispCount: 3});
        $('#selectMotor').parent().attr('style','display: flex;');
        $('#selectMotor').parent().attr('id','sumoMotor');
        //$('#selectMotor').on('change', (e) => this.props.onSelectChange(e.target.value, "motor"))

        $('#selectMarca').SumoSelect({  placeholder: 'Select Here',csvDispCount: 3});
        $('#selectMarca').parent().attr('style','display: flex;');
        $('#selectMarca').on('change', (e) => this.props.onSelectChange(e.target.value, "marca"))

        $('#selectCpls').SumoSelect({  placeholder: 'Select Here',csvDispCount: 3});
        $('#selectCpls').parent().attr('style','display: flex;');
        $('#selectCpls').parent().attr('id','sumoCpls');

        
       $("#sumoMotor li").bind('click.check', function(event) {
            //console.log(event)
            var selectedMotorIds = $('#selectMotor').val();
            self.props.onSelectChange(selectedMotorIds.join(","), "motor", () => {
                self.forceUpdate(() => {
                    //console.log(self.props.itemModel.customFieldsValues._motor.value)
                    $('#selectCpls.SumoUnder')[0].sumo.reload();
                    $('#selectCpls').parent().attr('id','sumoCpls');
                    $("#sumoCpls li").bind('click.check', function(event) {
           
                        var selectedMotorIds = $('#selectCpls').val();
                        //console.log(selectedMotorIds)
                        self.props.onSelectChange(selectedMotorIds.join(","), "cpls")
                    })
                    self.customizeSumoSelect()
                })
    
            })
        })

         
        $("#sumoCpls li").bind('click.check', function(event) {
           
            var selectedIds = $('#selectCpls').val();
            self.props.onSelectChange(selectedIds.join(","), "cpls")
        })

        $('#selectCategories').SumoSelect({  placeholder: 'Select Here', csvDispCount: 3});
        $('#selectCategories').parent().attr('style','display: flex;');
        $('#selectCategories').parent().attr('id','sumoCat');

        $("#sumoCat li").bind('click.check', function(event) {
            var selectedIds = $('#selectCategories').val();
            self.props.onSelectChange(selectedIds.join(","), "categories")
            //self.props.itemModel.categories
        })

       

        //                                                  //change the with of all sumoSelect... 
        //                                                  //  alway bottom this method

        self.customizeSumoSelect();
     
    }
    //-----------------------------------------------------------------------------------------------------------------
    customizeSumoSelect(){
        $('.SumoSelect').css('width', '100%');
        $('.CaptionCont').css('border-style', 'hidden hidden solid hidden');
        $('.form-control').css('box-shadow', 'none');
        $('.form-group label').css('font-weight', '200');
        $('.form-group label').css('color', 'gray');
        
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderNumeroParte(){
        let numPart = this.props.itemModel.customFieldsValues.numPart

       
        return ( <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputPassword4" value={numPart.value} onChange={(e) => this.props.onTextChange(e.target.value, "numpart")}/>)
        

    }
    //-----------------------------------------------------------------------------------------------------------------
    renderAntecesor(){
        let cf = this.props.itemModel.customFieldsValues.antecesor
        return ( <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "antecesor")}/>)
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderSupercesor(){

        let cf = this.props.itemModel.customFieldsValues.supercesor
        return ( <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "supercesor")}/>)


    }
    //-----------------------------------------------------------------------------------------------------------------
    renderCodeCore(){
        let cf = this.props.itemModel.customFieldsValues.codigoCore

        if (cf.value != '') {
            this.coreActive = true;
        } else {
            this.coreActive = false;
        }

        return ( <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "codigocore")}/>)
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderPartesRelacionadas(){
        let cf = this.props.itemModel.customFieldsValues.relatedParts
        return ( <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "relatedparts")}/>)
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderCorePrice(){
        let cf = this.props.itemModel.customFieldsValues.precioCore
        
        if(this.coreActive){
            return (<input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "preciocore")}/>)
        } else {
            return (<input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputPassword4" value={cf.value} onChange={(e) => this.props.onTextChange(e.target.value, "preciocore")} disabled/>)
        }

    }
    //-----------------------------------------------------------------------------------------------------------------
    renderPrice(){
        let price = this.props.itemModel.price;
        let priceString = price//.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
        if (price != null){
            return ( <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputPassword4" value={price} onChange={(e) => this.props.onTextChange(e.target.value, "itemprice")}/>)
        } else {
            return ( <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputPassword4" onChange={(e) => this.props.onTextChange(e.target.value, "itemprice")}/>)
        }

    }
    //-----------------------------------------------------------------------------------------------------------------
    renderImages() {
        let self = this;
        let images = this.props.itemModel.images;

        if (images != null) {
            return images.map(function (item, i) {
                return (
                    <div key={i} data-id={item.ID} className="uploded-box">
                        <img alt="" src={item.MediaUrl} />
                        <div className="action-area">
                            <a onClick={() => { self.props.removeImage(i) }}>
                                <i className="icon icon-close" />
                            </a>
                        </div>
                    </div>
                );
            });
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderMarcaOptions(){
        let self = this;
        let marcas = this.props.itemModel.categories.find(category => category.Name == "Marca");
        let marcaSelected = self.props.itemModel.customFieldsValues._marca.value

        if (marcas != null) {
            return marcas.ChildCategories.map(function (marca, i) {
                var selected = marca.Name == marcaSelected
                return (
                    <option selected={selected} key={marca.ID} data-id={marca.ID} id={marca.ID} value={marca.Name} >
                       {marca.Name}
                    </option>
                );
            });
        } 
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderCategoriesOptions(){
        let self = this;

        var categories = [];

        self.props.itemModel.categories.forEach(element => {
            if (element.Name != "Ofertas" && element.Name != "Marca") {
                categories.push(element)
            }
        });

        categories = categories.filter(category => category != null);
        if (categories != null) {
            return categories.map(function (category, i) {
                return (
                    <optgroup  key={i} label={category.Name}>
                        {
                            category.ChildCategories.map(function(child, idx){
                                return (
                                    <option selected={child.Selected == 'checked'} key={idx}  value={child.ID}>{child.Name}</option>
                                )
                            })
                        }
                    
                  </optgroup>
                );
            });
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderMotorsOptions(){
        let self = this;
        let motors = this.props.itemModel.motors;
        let motorSelected = self.props.itemModel.customFieldsValues._motor.value.split(",")
        motorSelected = motorSelected.filter(function(entry) { return /\S/.test(entry); });

        if (motors != null) {
            return motors.map(function (motor, i) {
                let selected = motorSelected.find(m => m == motor.motor.Nombre)
                if (motor.motor.Nombre != ""){
                    return (
                        <option selected={selected != null} key={i} data-id={motor.motor.Id} id={motor.motor.Id} value={motor.motor.Nombre} >
                           {motor.motor.Nombre}
                           
                        </option>
                    );
                }
            });
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderCPLsOptions(){
        let self = this;
        let motors = this.props.itemModel.motors;
        let motorsSelected = self.props.itemModel.customFieldsValues._motor.value.split(",")
      
        let cplsSelected = this.props.itemModel.customFieldsValues.cpl.value.split(",");
        
        if (motors != null) {
            return motors.map(function (motor, i) {
                let motorSelected = motorsSelected.find(m => m == motor.motor.Nombre)
                if(motorSelected){
                    return (
                        <optgroup  key={i} label={motor.motor.Nombre}>
                            {
                                motor.cpls.map(function(cpl, idx){
                                    let cplSeleced = cplsSelected.find(c => c == cpl.Nombre)
                                    return (
                                        <option  selected={cplSeleced != null}  key={idx}  value={cpl.Nombre}>{cpl.Nombre}</option>
                                    )
                                })
                            }
                        
                      </optgroup>
                    )
                };
            });
        }
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderNewForm(){
        var oferta = this.props.itemModel.categories.find(category => category.Name == "Ofertas")
        var isOfertaSelected = oferta ? oferta.Selected == 'checked' : false
        return(
            <div>
                <div className="row">
                    <div className="form-group col-md-6">
                    <label htmlFor="selectMarca">Marca</label>
                    <select /* multiple="multiple" */ className="form-control BO_inputField" style={{height:'auto'}} id="selectMarca" >
                        <option disabled selected>Seleccionar marca</option>
                        {this.renderMarcaOptions()}   
                    </select> 
                    </div>
                    <div className="form-group col-md-6">
                    <label htmlFor="inputPassword4">Número de parte</label>
                   {this.renderNumeroParte()}
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-6">
                    <label htmlFor="inputEmail4">Core</label>
                    {this.renderCodeCore()}
                    </div>
                    <div className="form-group col-md-6">
                    <label htmlFor="selectMotor">Motor</label>
                    <select  multiple="multiple"  className="form-control BO_inputField" style={{height:'auto'}} id="selectMotor">
                        {this.renderMotorsOptions()}   
                    </select>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-6">
                    <label htmlFor="selectCategories">Categoría</label>
                    <select multiple="multiple"  className="form-control BO_inputField required" style={{height:'auto'}} id="selectCategories" onChange={() => {console.log("aaaaaaaaaaaaaaaaa"); /*this.props.selectUnselectCategory(category.ID)*/}}>
                       {this.renderCategoriesOptions()}
                    </select>             
                    </div>
                    <div className="form-group col-md-6">
                    <label htmlFor="inputShortDesc">Descripción corta(máx 48 characteres)</label>
                    <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputShortDesc" value={this.props.itemModel.listingName} onChange={(e) => this.props.onTextChange(e.target.value, "shortdesc")}/>
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-12">
                    <label htmlFor="inputDescription">Descripción</label>
                    <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputDescription" value={this.props.itemModel.description} onChange={(e) => this.props.onTextChange(e.target.value, "description")}/>
                    </div>
                    {/*<div className="col-md-6">
                        <div className="form-group col-md-6">
                        <label htmlFor="check1"></label>
                            <div className="custom-control custom-checkbox" id="check1">
                                <input type="checkbox" className="custom-control-input" id="customCheck1"/>
                                <label className="custom-control-label" style={{marginLeft:'10px'}} htmlFor="customCheck1">Comparable</label>
                            </div>
                        
                        </div>

                        {/*<div className="form-group col-md-6">
                            <label htmlFor="check2"></label>
                            <div className="custom-control custom-checkbox" id="check2">
                            <input type="checkbox" className="custom-control-input" id="searchableCheck" defaultChecked={this.props.itemModel.itemSearchable} onChange={(e) => this.props.onChekChange(e.target.value, "searchable")} />
                            <label className="custom-control-label"style={{marginLeft:'10px'}}   htmlFor="searchableCheck">Buscable</label>
                            </div>
                        
                        </div>* /}
                    </div>*/}
                </div>

                <div className="row">
                    <div className="form-group col-md-6">
                    <label htmlFor="exampleFormControlSelect3">CPL</label>
                    <select  multiple="multiple"  className="form-control BO_inputField" style={{height:'auto'}} id="selectCpls">
                        {this.renderCPLsOptions()}   
                    </select>
                    </div>
                    <div className="form-group col-md-6">
                    <label htmlFor="inputPassword4">Partes relacionadas</label>
                    {this.renderPartesRelacionadas()}   
                    </div>
                </div>

                <div className="row">
                    <div className="form-group col-md-3">
                    <label htmlFor="inputEmail4">Precio de lista</label>
                    {this.renderPrice()}
                    </div>
                    <div className="form-group col-md-3">
                    <label htmlFor="inputPassword4">Precio CORE</label>
                    {this.renderCorePrice()}
                    </div>
                    <div className="form-group col-md-2">
                    <label htmlFor="inputCurrency">Moneda</label>
                    <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputCurrency" value={this.props.itemModel.customFieldsValues.currency.value} onChange={(e) => this.props.onTextChange(e.target.value, "currency")}/>
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="checkOfertaClear"></label>
                        <div className="custom-control custom-checkbox" id="checkOfertaClear">
                        <input type="checkbox" className="custom-control-input" id="checkOferta" defaultChecked={isOfertaSelected} onChange={(e) => this.props.onChekChange(e.target.value, "oferta")}/>
                        <label className="custom-control-label"style={{marginLeft:'10px'}}   htmlFor="checkOferta">Oferta</label>
                        </div>
                    </div>
                    <div className="form-group col-md-2">
                            <label htmlFor="check2"></label>
                            <div className="custom-control custom-checkbox" id="check2">
                            <input type="checkbox" className="custom-control-input" id="searchableCheck" defaultChecked={this.props.itemModel.itemSearchable} onChange={(e) => this.props.onChekChange(e.target.value, "searchable")} />
                            <label className="custom-control-label"style={{marginLeft:'10px'}}   htmlFor="searchableCheck">Buscable</label>
                            </div>
                        
                        </div>
                </div>

                <div className="row">
                   <div className="col-md-6">
                        <div className="row">
                            <div className="form-group col-md-3">
                            <label htmlFor="inputLength">Largo</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputLength" value={this.props.itemModel.itemLength ? this.props.itemModel.itemLength : ""} onChange={(e) => this.props.onTextChange(e.target.value, "itemlength")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputLengthUnit">U. de medida</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputLengthUnit" value={this.props.itemModel.itemLengthUnit} onChange={(e) => this.props.onTextChange(e.target.value, "itemlengthunit")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputWidth">Ancho</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputWidth" value={this.props.itemModel.itemWidth ? this.props.itemModel.itemWidth : ""} onChange={(e) => this.props.onTextChange(e.target.value, "itemwidth")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputWidthUnit">U. de medida</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputWidthUnit" value={this.props.itemModel.itemWidthUnit} onChange={(e) => this.props.onTextChange(e.target.value, "itemwidthunit")}/>
                            </div>
                        </div>
                   </div>

                   <div className="col-md-6">
                        <div className="row">
                            <div className="form-group col-md-3">
                            <label htmlFor="inputWeigth">Peso</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputWeigth" value={this.props.itemModel.itemWeigth ? this.props.itemModel.itemWeigth : ""} onChange={(e) => this.props.onTextChange(e.target.value, "itemweigth")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputWeigthUnit">U. de medida</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputWeigthUnit" value={this.props.itemModel.itemWeigthUnit} onChange={(e) => this.props.onTextChange(e.target.value, "itemweigthunit")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputHeight">Alto</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputHeight"  value={this.props.itemModel.itemHeigth ? this.props.itemModel.itemHeigth : ""} onChange={(e) => this.props.onTextChange(e.target.value, "itemheight")}/>
                            </div>
                            <div className="form-group col-md-3">
                            <label htmlFor="inputHeightUnit">U. de medida</label>
                            <input type="text" className="form-control BO_inputField" style={{height:'auto'}} id="inputHeightUnit" value={this.props.itemModel.itemHeightUnit} onChange={(e) => this.props.onTextChange(e.target.value, "itemheightunit")}/>
                            </div>
                        </div>
                   </div>
                </div>

                <div className="row">
                 
                    <div className="form-group col-md-3">
                        <label htmlFor="checkLTAClear"></label>
                        <div className="custom-control custom-checkbox" id="checkLTAClear">
                        <input type="checkbox" className="custom-control-input" id="checkLTA" defaultChecked={this.props.itemModel.customFieldsValues.lta.value == "1"} onChange={(e) => this.props.onChekChange(e.target.value, "lta")}/>
                        <label className="custom-control-label"style={{marginLeft:'10px'}}   htmlFor="checkLTA">LTA</label>
                        </div>
                    </div>
                    <div className="form-group col-md-3">
                        <label htmlFor="inputUnitSale">Unidad de venta</label>
                        <input type="text" className="form-control BO_inputField required" style={{height:'auto'}} id="inputUnitSale"  value={this.props.itemModel.customFieldsValues.unitSale.value} onChange={(e) => this.props.onTextChange(e.target.value, "unitsale")}/>
                    </div>
                
                    <div className="form-group col-md-3">
                        <label htmlFor="inputEmail4">Antecesor</label>
                        {this.renderAntecesor()}
                    </div>
                    <div className="form-group col-md-3">
                        <label htmlFor="inputPassword4">Supercesor</label>
                        {this.renderSupercesor()}
                    </div>
                      
                </div>
            
            </div>
        );
    }
    //-----------------------------------------------------------------------------------------------------------------
    renderButtonSave(){
        return(
            <div>
                <button type="button" className="btn btn-secondary" onClick={this.props.uploadOrEditData}> Guardar</button>
            </div>)
    }
    //-----------------------------------------------------------------------------------------------------------------
    render() {
        let self = this;

        return (
            <React.Fragment>
                <div className="header mod" id="header-section">
                    <HeaderLayout categories={this.props.categories} user={this.props.user} />
                </div>
                <aside className="sidebar" id="sidebar-section">
                    <SidebarLayout user={this.props.user} />
                </aside>
                <div className="main-content">
                    <div className="main">
                        {/*<div className="un-seller-tab">
                            <div className="container">
                               <ul id="seller-upload-tab" className="pull-left un-item-uplod-tab">
                                    <TabLinksComponent showTab={this.showTab} />
                                </ul>
                                <AddButtonComponent uploadOrEditData={this.props.uploadOrEditData}/>
                            </div>
                        </div>*/}
                        <div className="sticky-support"></div>
                        <div className="un-seller-body">
                            <div className="container">
                                <div className="tab-container tabcontent active" id="basic_tab">
                                    <div className="tab-title">
                                        <div className="tab-text">
                                            <span>Detalle de producto</span>
                                        </div>
                                    </div>
                                    <div className="tab-content un-inputs">
                                        {/*<div className="item-form-group">
                                            <div className="col-md-6">
                                                <div className="row">
                                                    <label>Listing Name*</label>
                                                    <input type="text" className="required"
                                                        name="listing-name"
                                                        id="listing_name"
                                                        defaultValue={this.props.itemModel.listingName}
                                                        onChange={(e) => this.props.onTextChange(e.target.value, "itemname")}
                                                        maxLength={130} />
                                                </div>
                                            </div>
                                        </div>*/}
                                     {this.renderNewForm()}
                                       {/* <CategoryComponent
                                            itemModel={this.props.itemModel}
                                            updateCategoryToSearch={this.props.updateCategoryToSearch}
                                            selectAllOrNone={this.props.selectAllOrNone}
                                            selectUnselectCategory={this.props.selectUnselectCategory} />
                                        <NegotiateComponent {...this.props} />*/}
                                        <div className="item-form-group">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <label>Imagen* ( Maximo 5 imagenes ) </label>
                                                    <p>Las imagenes deben de tener un radio de 1:1 y con un peso no mayor a 2MB (imagenes recomendadas 600px x 600 px)</p>
                                                    <div className="browse-image required" style={{width:'100%'}}>
                                                        <a data-toggle="modal" data-target="#myModal" href="#" id="btn-browse" onClick={() => this.browseFile()} />
                                                        <span className="icon-browse" />
                                                    </div>
                                                    <div className="uploded-items">
                                                        {this.renderImages()}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix" />
                                {/*<div className="tab-container tabcontent" id="description_tab">
                                    <div className="tab-title">
                                        <div className="tab-text">
                                            <span>Description</span>
                                        </div>
                                    </div>
                                    <div className="tab-content un-inputs">
                                        <div className="item-form-group">
                                            <div className="col-md-12">
                                                <label>Item Description*</label>
                                                <textarea className="required"
                                                    name="item-description"
                                                    onChange={(e) => this.props.onTextChange(e.target.value, "itemdescription")}
                                                    defaultValue={this.props.itemModel.description}
                                                    maxLength={5000}>
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className="item-form-line" />
                                        <div className="item-custom-fields full-width">
                                            <CustomFieldComponent
                                                itemModel={this.props.itemModel}
                                                checkboxClickedCustomField={this.props.checkboxClickedCustomField}
                                                dropDownChange={this.props.dropDownChange}
                                                onTextChange={this.props.onTextChange}
                                                setPDFFile={this.props.setPDFFile} />
                                        </div>
                                    </div>
                                </div>
                                <div className="clearfix" />
                                <PricingFeatureComponent
                                    {...this.props}
                                    showTab={this.showTab} />*/}

                                    {this.renderButtonSave()}
                            </div>
                        </div>
                    </div>
                    <div className="footer" id="footer-section">
                        <FooterLayout panels={this.props.panels} />
                    </div>
                </div>
                <div id="myModal" className="modal fade" role="dialog">
                    <ImageModalViewComponent
                        base={self}
                        addImage={this.addImage} />
                </div>
            </React.Fragment>
        );
    }
}
//=====================================================================================================================
const UploadEditHome = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadEditComponent);

module.exports = {
    UploadEditHome,
    UploadEditComponent,
};
//=====================================================================================================================
